// @mui
import {
	Box,
	Button,
	Card,
	CircularProgress,
	Container,
	IconButton,
	MenuItem,
	Paper,
	Popover,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import ConnectionMigrateDialog from "src/components/migrate/ConnectionMigrateDialog";
import StoreItemDialog from "src/components/store-item/StoreItemDialog";
import { del, get } from "src/utils/networkUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

export type StoreItem = {
	marketplaceStoreItemId: number;
	store: number;
	productId: "coins_100";
	name: string;
	description: string;
	image: string;
	listImage: string;
	amount: number;
	priceLabel: string;
	price: number;
	itemType: number;
};

export default function StoreItemsPage() {
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(null);
	const [openId, setOpenId] = useState(null);
	const [rows, setRows] = useState<StoreItem[]>([]);
	const [openPrizeDrawDialog, setOpenPrizeDrawDialog] = useState(false);
	const [connectionDialogOpen, setConnectionDialogOpen] = useState(false);
	const [item, setItem] = useState<StoreItem | null>(null);
	const { isViewer } = getUserPermissions();

	const getStoreItemType = (itemType: number) => {
		switch (itemType) {
			case 0:
				return "Coins";
			case 1:
				return "AllAccessPass";
			case 3:
				return "Ticket";
			default:
				return "Unknown";
		}
	};

	useEffect(() => {
		get(`/admin/marketplace/store-items`).then((response) => {
			setRows(response.items as StoreItem[]);
		});
	}, []);

	const handleOpenMenu = (event) => {
		setOpen(event.currentTarget);
		setOpenId(event.currentTarget.id);
	};

	const handleCloseMenu = () => {
		setOpen(null);
		setOpenId(null);
	};

	const handleCloseStageDialog = () => {
		setItem(null);
		setOpenPrizeDrawDialog(false);
	};
	const handleOpenEditStageDialog = (storeItemId: number) => {
		const item = rows.find((item) => +item.marketplaceStoreItemId === +storeItemId);
		if (item) {
			setItem(item);
			setOpenPrizeDrawDialog(true);
			setOpen(null);
			setOpenId(null);
		}
	};
	const handleDeletePrizeDraw = (storeItemId: number) => {
		setLoading(true);
		setOpen(null);
		setOpenId(null);
		del(`/admin/marketplace/store-items/${storeItemId}`).then((response) => {
			window.location.reload();
		});
	};
	const handleSuccessStageDialog = () => {
		// window.location.reload();
	};

	return (
		<>
			<Helmet>
				<title> Store Items </title>
			</Helmet>

			<Container>
				<Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
					<Typography variant="h4" gutterBottom>
						Store Items
					</Typography>
					<Stack direction="row" spacing={2}>
						<Button variant="contained" startIcon={<Iconify icon="eva:swap-outline" />} onClick={() => setConnectionDialogOpen(true)}>
							Migrate Data
						</Button>
						<Button variant="contained" startIcon={<Iconify icon="eva:plus-outline" />} onClick={() => setOpenPrizeDrawDialog(true)}>
							Create Store Item
						</Button>
					</Stack>
				</Stack>

				<Card>
					{rows === null || loading ? (
						<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
							<CircularProgress />
						</Box>
					) : (
						<Scrollbar>
							<TableContainer component={Paper}>
								<Table sx={{ minWidth: 650 }} aria-label="simple table">
									<TableHead>
										<TableRow>
											<TableCell>ID</TableCell>
											<TableCell>Store</TableCell>
											<TableCell>Name</TableCell>
											<TableCell>Amount</TableCell>
											<TableCell>Type</TableCell>
											<TableCell>List Image</TableCell>
											<TableCell>Image</TableCell>
											<TableCell align="right"></TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{rows.map((row, index) => (
											<TableRow
												key={index}
												sx={{
													"&:last-child td, &:last-child th": { border: 0 },
												}}
											>
												<TableCell component="th" scope="row">
													{row.marketplaceStoreItemId}
												</TableCell>
												<TableCell component="th" scope="row">
													{row.store === 0 ? "Apple" : "Google"}
												</TableCell>
												<TableCell component="th" scope="row">
													{row.name}
												</TableCell>
												<TableCell component="th" scope="row">
													{row.amount}
												</TableCell>
												<TableCell component="th" scope="row">
													{getStoreItemType(row.itemType)}
												</TableCell>

												<TableCell component="th" scope="row">
													{row.listImage ? (
														<img
															style={{
																margin: "0 auto",
																width: 100,
																background: "grey",
															}}
															alt="Store Item"
															src={row.listImage}
														/>
													) : null}
												</TableCell>
												<TableCell component="th" scope="row">
													{row.image ? (
														<img
															style={{
																margin: "0 auto",
																width: 100,
																background: "grey",
															}}
															alt="Store Item"
															src={row.image}
														/>
													) : null}
												</TableCell>
												<TableCell align="right">
													<IconButton size="large" color="inherit" onClick={handleOpenMenu} id={row.marketplaceStoreItemId}>
														<Iconify icon={"eva:more-vertical-fill"} />
													</IconButton>
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						</Scrollbar>
					)}
				</Card>
			</Container>
			{!isViewer && (
				<Popover
					open={Boolean(open)}
					anchorEl={open}
					onClose={handleCloseMenu}
					anchorOrigin={{ vertical: "top", horizontal: "left" }}
					transformOrigin={{ vertical: "top", horizontal: "right" }}
					PaperProps={{
						sx: {
							p: 1,
							width: 140,
							"& .MuiMenuItem-root": {
								px: 1,
								typography: "body2",
								borderRadius: 0.75,
							},
						},
					}}
				>
					<MenuItem onClick={() => handleOpenEditStageDialog(openId)}>
						<Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
						Edit
					</MenuItem>
					<MenuItem onClick={() => handleDeletePrizeDraw(openId)}>
						<Iconify icon={"eva:trash-outline"} sx={{ mr: 2 }} />
						Delete
					</MenuItem>
				</Popover>
			)}

			{openPrizeDrawDialog && (
				<StoreItemDialog
					item={item}
					open={openPrizeDrawDialog}
					onSuccessHandler={handleSuccessStageDialog}
					onClose={handleCloseStageDialog}
				/>
			)}
			<ConnectionMigrateDialog
				open={connectionDialogOpen}
				onClose={() => setConnectionDialogOpen(false)}
				title="Marketplace Store Items Data Migration"
				description="Migrates Store Items from current database to below database. It creates new store items, existing store items are not updated."
				apiEndpoint="/admin/marketplace/coins/migration"
				entityName="marketplace coins"
			/>
		</>
	);
}
